import _extends from 'babel-runtime/helpers/extends';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { getAllowedAttributes } from '../props-filters';
import * as style from './CarouselItem.style';

var CarouselItem = function (_PureComponent) {
  _inherits(CarouselItem, _PureComponent);

  function CarouselItem() {
    _classCallCheck(this, CarouselItem);

    return _possibleConstructorReturn(this, (CarouselItem.__proto__ || _Object$getPrototypeOf(CarouselItem)).apply(this, arguments));
  }

  _createClass(CarouselItem, [{
    key: 'render',
    value: function render() {
      var _ref;

      var _props = this.props,
          children = _props.children,
          active = _props.active,
          theme = _props.theme,
          innerRef = _props.innerRef,
          bare = _props.bare,
          restProps = _objectWithoutProperties(_props, ['children', 'active', 'theme', 'innerRef', 'bare']);

      var itemClassName = cx(style.item, !bare && (_ref = {}, _defineProperty(_ref, style.itemCursorPointer, true), _defineProperty(_ref, style.itemActive, active), _defineProperty(_ref, style.itemUnderline, active), _defineProperty(_ref, style.itemThemed(theme), true), _ref));
      var allowedAttributes = getAllowedAttributes(restProps);
      return React.createElement(
        'div',
        _extends({}, allowedAttributes, { className: itemClassName, ref: innerRef }),
        children
      );
    }
  }]);

  return CarouselItem;
}(PureComponent);

CarouselItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  theme: PropTypes.oneOf(['light', 'dark']).isRequired,
  innerRef: PropTypes.func,
  bare: PropTypes.bool
};
export default CarouselItem;